import { Service } from "typedi";
import { DeviceStatusDTO } from "../../../../../schools-backend/src/student/application/dtos/StudentDeviceStatusDTO";

type Listener = (status: DeviceStatusDTO | null) => void;

@Service()
export class DeviceStatusCache {
    private status: DeviceStatusDTO | null = null;
    private readonly listeners = new Set<Listener>();

    get(): DeviceStatusDTO | null {
        return this.status;
    }

    set(status: DeviceStatusDTO | null): void {
        this.status = status;
        this.listeners.forEach((l) => {
            try { l(status); } catch (err) { console.error("[device-status-cache] listener error", err); }
        });
    }

    onChange(listener: Listener): () => void {
        this.listeners.add(listener);
        return () => this.listeners.delete(listener);
    }
}
